import React from 'react';
import {FISH_HEALTH, fishHealth} from "../../../util/varibles/constants";

interface IProps {
    value?: FISH_HEALTH | null
}

const FishHealth: React.FC<IProps> = ({value}) => {
    if (!value)
        return  null;

    const {name, color, bg} = fishHealth[value] || {};

    return <span
        className={"h-[32px] rounded-2xl px-[12px] py-[6px] text-[14px]"}
        style={{background: bg, color}}
    >
        {name}
    </span>;
};

export default FishHealth;
